import { supabase } from "@/integrations/supabase/client";

export async function logActivity(
  action: string,
  details: Record<string, unknown>,
  entity_id: string,
  entity_type: string,
) {
  const {
    data: { user },
  } = await supabase.auth.getUser();

  if (!user) return false;

  const { error } = await supabase.functions.invoke("log-activity", {
    body: {
      action,
      details,
      entity_id,
      entity_type,
      matter_id: entity_type === "matter" ? entity_id : null,
      deal_id: entity_type === "deal" ? entity_id : null,
    },
  });

  if (error) {
    console.warn("Audit log failed", error);
    return false;
  }

  return true;
}
